import { createContext, useContext, useState, useEffect } from "react";
import { API_BASE } from "../api/config";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [loginType, setLoginType] = useState("");
  const [branch, setBranch] = useState("");         // ✅ NEW: branch state
  const [companyName, setCompanyName] = useState("");
  const navigate = useNavigate();

  // ✅ Fetch company name on mount
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=company&transac=get`
        );
        const result = await response.json();
        if (result.status === "ok" && result.data.length > 0) {
          setCompanyName(result.data[0].company_name);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    fetchCompany();

    // ✅ Load auth from localStorage
    const storedAuth = localStorage.getItem("isAuthenticated");
    const storedUser = localStorage.getItem("username");
    const storedType = localStorage.getItem("loginType");
    const storedBranch = localStorage.getItem("branch"); // ✅ load branch

    if (storedAuth === "true" && storedUser) {
      setIsAuthenticated(true);
      setUsername(storedUser);
      setLoginType(storedType || "");
      setBranch(storedBranch || "");
    }
  }, []);

  // ✅ Accept branch when logging in
  const login = (user, type, branchName) => {
    setIsAuthenticated(true);
    setUsername(user);
    setLoginType(type);
    setBranch(branchName || "");
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("username", user);
    localStorage.setItem("loginType", type);
    localStorage.setItem("branch", branchName || "");
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUsername("");
    setLoginType("");
    setBranch("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("username");
    localStorage.removeItem("loginType");
    localStorage.removeItem("branch");
    navigate("/"); // go back to login
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        username,
        loginType,
        branch,          // ✅ expose branch
        login,
        logout,
        companyName
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
